import React, { useContext } from 'react';
import { prop } from 'ramda';
import { getURLParam } from 'js/utils/url.util';
import { usePageSelector } from 'js/store/hooks';
import { WebContent } from 'js/components/system/WebContent';
import { componentService } from 'js/services/component.service';
import { AppContext } from 'js/components/system/App/store/context';

import style from './Footer.scss';

export const Footer = () => {
    const { addLoadingPromise } = useContext(AppContext);
    const footerPageWCID = usePageSelector(prop('footer'));
    const hideFooterByUrl = getURLParam(location.search, 'hideFooter') === '1';

    if (hideFooterByUrl) {
        return null;
    }

    if (footerPageWCID) {
        return (
            <footer className={style.footer}>
                <WebContent id={footerPageWCID} addLoadingPromise={addLoadingPromise} />
            </footer>
        );
    }

    return null;
};

componentService.registerWebContentComponents({ Footer });
